<template>
  <div class="pullPlugUpsetBox" v-show="show">
    <!-- 卖家终止弹窗 -->
    <div class="main">
      <div class="title">
        <div class="left">终止原因</div>
        <div class="right">(必选)</div>
      </div>
      <div class="radio-group">
        <el-radio-group v-model="causeValue">
          <el-radio :label="item.lable" v-for="item in causeData" :key="item.value">{{ item.lable }}<span :style="{'color': '#999999', 'font-size': '12px', 'font-weight': '400', 'display': 'block', 'margin-top': '3px'}">({{ item.text }})</span></el-radio>
        </el-radio-group>
      </div>
      <div class="tip">
        <img src="@/assets/image/PersonalCenter/Seller/BargainPrice/smile.png" alt="">
        <span>为了给您提供更好的服务，请选择最符合终止议价原因</span>
      </div>
      <div class="btn-group">
        <el-button @click.stop="causeValue='',$emit('update:show',false)" class="btn">取消终止</el-button>
        <el-button :disabled="disabled" v-preventReClick='1000' @click.stop="submitCause" class="btn">确认终止</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  apiEarnestOrderOff,
} from "@/request/API";
export default {
  name: 'pullPlugUpset',
  props: {
    // 是否显示
    show: {
      type: Boolean,
      default: false
    },
    // 当前订单id
    id: {
      type: [Number, String],
      default: ''
    },
  },
  data() {
    return {
      disabled: false,
      causeValue: '',
      // 终止原因
      causeData: [
        { lable: '继续出售', value: 1, text: '仅终止当前议价', is_red: false },
        { lable: '买家出价太低', value: 2, text:'仅终止当前议价', is_red: false },
        { lable: '已在其他平台出售', value: 3, text:'平台将自动终止其他议价，并下架该账号', is_red: true },
        { lable: '不出售了', value: 4, text: '平台将自动终止其他议价，自动下架账号', is_red: true },
        { lable: '账号出问题了', value: 5, text: '平台将自动终止其他议价，自动下架账号', is_red: true },
      ],
    }
  },
  watch: {
    show(val){
      if(val){
        this.touchmoveDisable()
      } else {
        this.touchmoveY()
      }
    }
  },
  methods: {
    /**
     * @description: 确认终止
     * @return {*}
     */
    submitCause() {
      if(this.causeValue == ''){
        this.$message.error('请选择终止原因')
        return
      }
      // 请求接口成功后提示：您已终止议价
      apiEarnestOrderOff({
        id: this.id,
        reason: this.causeValue
      }).then(res => {
        this.$message({
          message: res.data,
          center: true,
          offset: 350,
          customClass: 'counteroffer-msg',
        })
        this.causeValue = ''
        this.$emit('refreshData')
        this.$emit('update:show',false)
      }).catch(e => {
        if(e.code == 10012){
          this.$message.error(e.msg)
          this.$emit('refreshData')
          this.$emit('update:show',false)
        }
      })
    },
    /**
     * @description: 禁止页面滑动
     * @return {*}
     */
     touchmoveDisable() {
      let body = document.getElementsByTagName('body')
      body[0].style.overflow = 'hidden'
    },
    /**
     * @description: 页面滑动
     * @return {*}
     */
    touchmoveY() {
      let body = document.getElementsByTagName('body')
      body[0].style['overflowY'] = 'auto'
    },
  },
}
</script>

<style lang="less" scoped>
.pullPlugUpsetBox{
  width: 100vw;
  height: 100vh;
  background: rgba(15, 23, 42, 0.48);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1001;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  .main{
    width: 422px;
    // height: 400px;
    box-sizing: border-box;
    border-radius: 4px;
    background: var(--bg-card, #FFF);
    padding: 24px 30px 30px;
    filter: drop-shadow(0 18px 46px rgba(26, 29, 36, 0.14));
    .title{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 20px;
      // border-bottom: 1px #efefef solid;
      .left{
        color: var(--text-main, #111827);
        font-family: PingFang SC;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
      }
      .right{
        color: var(--text-muted, #9AA0AC);
        font-family: PingFang SC;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }
    }
    .radio-group{
      // padding: 20px 0 0;
      /deep/.el-radio-group{
        display: flex;
        flex-direction: column;
        .el-radio{
          margin: 0;
          border-top: 1px solid var(--border-soft, #E8E4DE);
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-direction: row-reverse;
          padding: 10px 0;
          .el-radio__label{
            padding: 0;
            color: var(--text-main, #111827);
            font-family: PingFang SC;
            font-size: 15px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
          }
          .el-radio__inner{
            width: 16px;
            height: 16px;
            border-color: var(--border-strong, #D8D2CA);
            &::after{
              background: var(--primary, #FF5A1F);
              width: 10px;
              height: 10px;
            }
          }
          .el-radio__input.is-checked .el-radio__inner{
            border-color: var(--primary, #FF5A1F);
            background: #fff;
          }
          .el-radio__input.is-checked+.el-radio__label{
            color: var(--primary, #FF5A1F);
          }
        }
      }
    }
    .tip{
      width: 337px;
      height: 29px;
      border-radius: 4px;
      background: var(--bg-tag, #F0EDE8);
      display: flex;
      justify-content: center;
      align-items: center;
      color: var(--text-main, #1A1D24);
      font-family: PingFang SC;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      margin: 20px auto 33.5px;
      img{
        margin-right: 5px;
      }
    }
    .btn-group{
      display: flex;
      justify-content: center;
      align-items: center;
      .btn{
        display: flex;
        width: 160px;
        height: 40px;
        justify-content: center;
        align-items: center;
        border-radius: 4px;
        border: 1.5px solid var(--bg-dark, #1A1D24);
        background: var(--bg-card, #FFFFFF);
        color: var(--text-main, #1A1D24);
        text-align: center;
        font-family: PingFang SC;
        font-size: 15px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        transition: box-shadow .2s ease, opacity .2s ease, background .2s ease;
        &:hover{
          background: var(--bg-tag, #F0EDE8);
        }
        &:last-child{
          background: var(--primary, #FF5A1F);
          border-color: transparent;
          color: #FFFFFF;
          margin-left: 20px;
          &:hover{
            background: var(--primary-hover, #E84A12);
            box-shadow: none;
            opacity: 1;
          }
        }
      }
    }
  }
}
</style>
